import React from "react"
import clsx from "clsx"
import { UniversalLink } from "../UniversalLink"
import type { Navigation } from "./navigation"

interface NavLinkProps {
  nav: Navigation
  className?: string
}

export const NavLink: React.FC<NavLinkProps> = ({ className, nav }) => (
  <UniversalLink
    to={nav.href}
    className={clsx(`nav-link nav-link-${nav.key}`, className)}
    partiallyActive={!nav.home}
    data-title={nav.name}
  >
    {nav.name}
  </UniversalLink>
)
